import OnboardingService from '@forwardflow/services/OnboardingService'
import useSWR from 'swr'
import { gated } from '@forwardflow/utils/sandbox'

export default function useSetupProgress() {
   const response = useSWR(
      gated('/onboarding/setup-progress'),
      OnboardingService.getOnboardingProgress
   )
   return {
      ...response,
   }
}
